/**
 * Entry point for the Hive Homes React app — referenced from src/index.html.
 *
 * In dev (`bun --hot src/index.ts`) we attach the React root to
 * `import.meta.hot.data` so hot-reloads do not unmount the app. The Bun
 * bundler rewrites `import.meta.hot` away in production builds, but it
 * requires us to access `.data` directly (no aliasing), so we branch on a
 * `typeof import.meta.hot` check.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

if (typeof import.meta.hot !== "undefined") {
  (import.meta.hot.data.root ??= createRoot(elem)).render(app);
} else {
  createRoot(elem).render(app);
}
